export default {
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.account.settings': '个人信息',
  'menu.account.logout': '退出登录',

  'menu.marketing': '大数据中心',
  'menu.marketing.analysis': '远程看房数据',
  'menu.marketing.list': '客户数据',
  'menu.marketing.detail': '客户详情',

  // 'menu.customer': '客户管理',

  'menu.member': '销售人员管理',
  'menu.member.saler': '入离职管理',
  'menu.member.salerData': '销售人员数据',

  'menu.trafficReport': '流量报表',

  'menu.developersManager': '开发商管理',

  'menu.buildingManager': '云端设置',
  'menu.buildingManager.list': '观览空间管理',
  'menu.buildingManager.buildingDetail': '楼盘信息',
  'menu.buildingManager.buildingRoom': '房间信息',
  'menu.buildingManager.buildingRoom.robotPoint': '点位资料配置',
  'menu.buildingManager.robotLoaclGuide': '本地导览素材',

  'menu.miniProgram': '系统设置',
  'menu.miniProgram.miniprogram': '小程序设置',
  'menu.miniProgram.h5setting': 'H5 设置',
  'menu.miniProgram.robot': '机器人配置',
  'menu.miniProgram.robotDetail': '机器人详情',
  'menu.miniProgram.robotGreet': '打招呼配置',

  'menu.accountManager': '账号管理',
  'menu.accountManager.User': '账号列表',
  'menu.accountManager.Role': '角色列表',

  'menu.personal': '个人信息',
  'menu.NLP': 'NLP',
}
